<template>
  <div class="store-form">
    <b-container>
      <b-row>
        <b-col>
            <b-form @submit.prevent="submitStore">
              <b-form-row>
                <div class="form-group col-12">
                  <label for="store-reference" v-translate>Store Name/Reference</label>
                  <div class="input-group">
                    <b-form-input
                      v-model="store.reference"
                      id="store-reference"
                      type="text"
                      style="font-size: 2rem"
                      required
                      size="xl"
                    ></b-form-input>
                  </div>
                </div>
                <div class="form-group col-sm-8">
                  <label for="store-address" v-translate>Address</label>
                  <div class="input-group" v-if="!formatted_address">
                    <div class="input-group">
                      <address-autocomplete ref="addressAutocomplete" @selected="checkStorePlace" :min-character="4" required />
                    </div>
                    <small class="form-text text-muted" v-translate>We use Google to validate all addresses, please keep it in mind when you enter yours.</small>
                  </div>
                  <p v-else>
                    {{formatted_address}}
                    <b-button variant="danger" size="sm" @click="addressAcInput = ''; formatted_address = ''; store.place_id = null" class="px-1 py-0">✕</b-button>
                  </p>
                  <b-modal size="lg" id="modalPickPlace" ref="modalPickPlace" hide-footer hide-header @hide="$refs.pickPlaceMap.pickPlace(0, 0)">
                    <place-picker ref="pickPlaceMap" @cancel="closeModalPickPlace" @placePicked="setPlacePicked" centerMap fit-always :zoom="17" />
                  </b-modal>
                </div>
                <div class="form-group col-sm-4">
                  <label for="store-address_extra" v-translate>Floor, door, etc.</label>
                  <div class="input-group">
                    <b-form-input id="store-address_extra" v-model="store.address_extra" class="col-12 form-control" />
                  </div>
                </div>
                <div class="form-group col-12">
                  <label for="store-contact" v-translate>Contact Name</label>
                  <div class="input-group">
                    <b-form-input id="store-contact" v-model="store.contact" class="col-12 form-control" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="store-email" v-translate>Contact Email</label>
                  <div class="input-group">
                    <b-form-input id="store-email" v-model="store.email" class="col-12 form-control" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="store-phone" v-translate>Contact Phone</label>
                  <div class="input-group">
                    <cleave ref="storePhone" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="col-12 form-control" v-model="store.phone"></cleave>
                  </div>
                </div>
              </b-form-row>
              <b-form-row>
                <b-col cols="12">
                  <h4 class="mb-3" v-translate>Business Hours</h4>
                  <b-row v-for="(day, i) in schedule" :key="i" class="mb-3">
                    <b-col lg="2" class="align-self-center">
                      {{ day.dayName }}
                    </b-col>
                    <b-col lg="10">
                      <b-form-select v-model="store.schedule[i]['businessHours'][0]['from']" :options="timeSlots"
                      :required="store.schedule[i]['businessHours'][0]['to'] !== '' && store.schedule[i]['businessHours'][0]['to'] !== null"
                      style="width: auto; display: inline-block">
                        <template slot="first">
                          <option :value="null">--:--</option>
                        </template>
                      </b-form-select>
                      <translate translate-context="fromHourToHour">to</translate>
                      <b-form-select v-model="store.schedule[i]['businessHours'][0]['to']" :options="timeSlots"
                      :required="store.schedule[i]['businessHours'][0]['from'] !== '' && store.schedule[i]['businessHours'][0]['from'] !== null"
                      style="width: auto; display: inline-block">
                        <template slot="first">
                          <option :value="null">--:--</option>
                        </template>
                      </b-form-select>
                      <translate translate-context="fromHourToHourAndFromHourToHour">and</translate>
                      <b-form-select v-model="store.schedule[i]['businessHours'][1]['from']" :options="timeSlots"
                      :required="store.schedule[i]['businessHours'][1]['to'] !== '' && store.schedule[i]['businessHours'][1]['to'] !== null"
                      style="width: auto; display: inline-block">
                        <template slot="first">
                          <option :value="null">--:--</option>
                        </template>
                      </b-form-select>
                      <translate translate-context="fromHourToHour">to</translate>
                      <b-form-select v-model="store.schedule[i]['businessHours'][1]['to']" :options="timeSlots"
                      :required="store.schedule[i]['businessHours'][1]['from'] !== '' && store.schedule[i]['businessHours'][1]['from'] !== null"
                      style="width: auto; display: inline-block">
                        <template slot="first">
                          <option :value="null">--:--</option>
                        </template>
                      </b-form-select>
                      <b-button class="px-3" size="sm" variant="primary" @click="replicateToMonToFrid" v-if="i === 0" :disabled="!store.schedule[0]['businessHours'][0].from || !store.schedule[0]['businessHours'][0].to" v-translate>
                        Copy from M to F
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-row>
              <div class="text-right form-group col-12 form-actions">
                <b-button type="submit" variant="primary" size="lg" v-translate>Save</b-button>
                <b-button variant="outline-primary" size="lg" @click.prevent="closeModal('modalStoreForm')" v-translate>Cancel</b-button>
              </div>
            </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AddressesMixin from '@/mixins/address.mixin'
import AddressAutocomplete from '@/components/Autocompletes/AddressAutocomplete'
import Cleave from 'vue-cleave'
import PlacePicker from '@/components/PlacePicker'

export default {
  name: 'StoreForm',
  components: {
    AddressAutocomplete,
    Cleave,
    PlacePicker
  },
  props: {
    store: {
      type: Object,
      default: function () {
        return {
          id: null,
          reference: null,
          place_id: null,
          address_extra: '',
          schedule: [],
          company_id: null
        }
      }
    }
  },
  data() {
    return {
      schedule: [],
      formatted_address: '',
      dismissSecs: 10,
      dismissCountDown: 0,
      eventAreas: [],
      timeSlots: new Array(24 * 2 + 1).fill(0).map((_, i) => {
        return {
          text: ('0' + ~~(i / 2) + ':0' + 60 * (i / 2 % 1)).replaceAll(/\d(\d\d)/g, '$1'),
          value: ('0' + ~~(i / 2) + ':0' + 60 * (i / 2 % 1)).replaceAll(/\d(\d\d)/g, '$1')
        }
      })
    }
  },
  watch: {
    updatedDateRangeActive: {
      handler (val) {
        if (val !== 0) {
          this.event.from_date = this.moment.utc(this.updatedDateRange.startDate).seconds(0).format('YYYY-MM-DD HH:mm:ss')
          this.event.to_date = this.moment.utc(this.updatedDateRange.endDate).seconds(0).format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.event.from_date = null
          this.event.to_date = null
        }
      },
      deep: true
    },
    'store.phone': {
      handler(val) {
        if (val.length > 0 && !val.includes('+')) {
          this.$refs.storePhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix + val.replaceAll(/\s/g, ''))
        } else if (val.length === 0) {
          this.$refs.storePhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix)
        } else {
          this.$refs.storePhone.cleave.setRawValue(val.replaceAll(/\s/g, ''))
        }
      },
      deep: true
    }
  },
  mixins: [
    AddressesMixin
  ],
  created() {
    if (this.store.place_id) {
      this.$http.get(this.$appConfig.api.baseUrl + 'places/' + this.store.place_id)
        .then(response => {
          this.formatted_address = response.data.formatted_address
        })
    }
    const companyMomentLocale = this.moment.localeData(window.countries.find(x => x.iso_code === this.$store.getters.profile.company.country_iso_code).front_config.i18n.moment)
    const companyLocaleWeekdays = [...companyMomentLocale.weekdays()]
    // reorder weekdays to force start on Monday
    companyLocaleWeekdays.push(companyLocaleWeekdays.shift())
    for (const weekday of companyLocaleWeekdays) {
      this.schedule.push({
        dayName: weekday.charAt(0).toUpperCase() + weekday.slice(1),
        businessHours: [
          {
            from: null,
            to: null
          },
          {
            from: null,
            to: null
          }
        ]
      })
    }
    this.store.schedule = this.mergeSchedule({ ...this.schedule }, { ...this.store.schedule }) // {...this.schedule, ...this.store.schedule}
    if (!this.store.id) {
      this.store.company_id = this.$store.getters.profile.company_id
    }
  },
  mounted() {
    if (this.store.phone.length > 0 && !this.store.phone.includes('+')) {
      this.$refs.storePhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix + this.store.phone.replaceAll(/\s/g, ''))
    } else if (this.store.phone.length === 0) {
      this.$refs.storePhone.cleave.setRawValue('+' + this.$frontConfig.i18n.phonePrefix)
    } else {
      this.$refs.storePhone.cleave.setRawValue(this.store.phone.replaceAll(/\s/g, ''))
    }
  },
  methods: {
    mergeSchedule(...objects) {
      const isObject = obj => obj && typeof obj === 'object'

      return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach(key => {
          const pVal = prev[key]
          const oVal = obj[key]

          if (isObject(pVal) && isObject(oVal)) {
            prev[key] = this.mergeSchedule(pVal, oVal)
          } else {
            prev[key] = oVal
          }
        })

        return prev
      }, {})
    },
    async checkStorePlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.store.place_id = this.theCheckedAddress.id
          this.formatted_address = this.theCheckedAddress.formatted_address
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = {
              lat: this.theCheckedAddress.lat,
              lng: this.theCheckedAddress.lng
            }
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
    },
    setPlacePicked(place) {
      this.formatted_address = place.formatted_address
      this.store.place_id = place.id
      this.$refs.modalPickPlace.hide()
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    },
    formattedDisplay(result) {
      return result.main_text + ', ' + result.secondary_text
    },
    replicateToMonToFrid() {
      for (let i = 1; i < this.schedule.length - 2; i++) {
        this.store.schedule[i].businessHours = []
        for (let n = 0; n < this.schedule[0].businessHours.length; n++) {
          this.store.schedule[i].businessHours.push({ ...this.store.schedule[0].businessHours[n] })
        }
      }
    },
    submitStore() {
      if (!this.store.id) {
        delete this.store.id
        delete this.store.place
        this.store.schedule = Object.values(this.store.schedule)
        this.$http.post(this.$appConfig.api.baseUrl + 'companies/' + this.store.company_id + '/stores', this.store)
          .then(response => {
            this.closeModal('modalStoreForm')
          })
      } else {
        const theId = this.store.id
        delete this.store.id // Needed to avoid API missunderstanding within Company ID
        delete this.store.created_at
        delete this.store.updated_at
        delete this.store.deleted_at
        delete this.store.place
        this.store.schedule = Object.values(this.store.schedule)
        this.$http.patch(this.$appConfig.api.baseUrl + 'companies/' + this.store.company_id + '/stores/' + theId, this.store)
          .then(response => {
            this.closeModal('modalStoreForm')
          })
      }
    },
    closeModal(id) {
      this.$root.$emit('bv::hide::modal', id)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
